<!-- ----------------------------------------------- -->
<template>
  <div :class="'tm-list'" @click="clickOver">
    <v-row align="center" justify="center" class="tm-list-child">
      <v-card class="com-popup com-popup-tm-list">
        <v-list
          class="tm-info pa-0"
          v-for="(tmInfo, index) in overlapTmList"
          :key="index"
        >
          <v-list-item class @click="selectTm(tmInfo)">
            <div class="pr-4">
              <v-img :src="tmInfo.iconPath" max-width="30px"></v-img>
            </div>
            {{ getTmName(tmInfo.itmkndCd, tmInfo.name) }}
          </v-list-item>
        </v-list>
      </v-card>
    </v-row>
  </div>
</template>
<!-- ----------------------------------------------- -->
<script>
import mixin from "../../lib/mixin.js";

/**
 * 川の防災情報 地図画面 観測所選択ダイアログ
 * TmList.vue
 * @author LIS
 */
export default {
  name: "map-tm-list",
  mixins: [mixin],
  data() {
    return {
      /** 文字列リソース */
      text: {
        water: "水位観測",
        rain: "雨量",
        quality: "水質",
        dam: "ダム",
        sea: "海岸",
        snow: "積雪深",
        swstg: this.$store.state.app.config.replaceNameConfig.swstg,
        camera: "河川カメラ",
        scamera: "簡易カメラ",
      },
    };
  },
  /** 算出部 */
  computed: {
    /** 重複表示観測所一覧 */
    overlapTmList() {
      return this.$store.state.map.overlapTmList;
    },
    /** 観測日時を取得 */
    appTime() {
      return this.$store.state.app.appTime;
    },
  },
  /** メソッド */
  methods: {
    /** 背景部クリックイベント */
    clickOver() {
      // 観測所一覧ダイアログを閉じる
      this.$store.commit("map/setShowTmList", false);
    },
    /** 観測所クリックイベント */
    selectTm(tmInfo) {
      // 画面遷移
      if (tmInfo.itmkndCd === 100 || tmInfo.itmkndCd === 200) {
        // カメラ
        this.$store.commit("Telemeter/setSelectedTmParamScam", {
          itmkndCd: tmInfo.itmkndCd,
          scamId: tmInfo.scamId,
          ownCd: tmInfo.ownCd,
          sysCamId: tmInfo.sysCamId,
        });
        // 地図アイコンからの遷移フラグを設定
        this.$store.commit("Telemeter/setMapIconFlg", true);
        if (this.$store.state.app.mode == "pc") {
          this.routerPushTmScam("/pc/tm");
        } else {
          this.routerPushTmScam("/mb/tm");
        }
      } else if (tmInfo.itmkndCd === 300) {
        // 危機管理型水位
        this.$store.commit("Swin/setSelectedSwParam", {
          swofcCd: tmInfo.swofcCd,
          itmkndCd: tmInfo.itmkndCd,
          swobsCd: tmInfo.swobsCd,
        });
        // 地図アイコンからの遷移フラグを設定
        this.$store.commit("Telemeter/setMapIconFlg", true);
        if (this.$store.state.app.mode == "pc") {
          this.routerPushTmSw("/pc/tm");
        } else {
          this.routerPushTmSw("/mb/tm");
        }
      } else {
        // 観測所
        const obsFcd = tmInfo.obsFcd;
        this.$store.commit("Telemeter/setSelectedTmParam", {
          ofcCd: Number(obsFcd.substr(0, 5)),
          itmkndCd: tmInfo.itmkndCd,
          obsCd: Number(obsFcd.substr(8, 5)),
        });
        // 地図アイコンからの遷移フラグを設定
        this.$store.commit("Telemeter/setMapIconFlg", true);
        if (this.$store.state.app.mode == "pc") {
          this.routerPushTm("/pc/tm");
        } else {
          this.routerPushTm("/mb/tm");
        }
      }
    },
    /** 表示観測所名設定 */
    getTmName(itmkndCd, name) {
      switch (itmkndCd) {
        // 水位
        case 4:
          return name + " (" + this.text.water + ")";
        // 雨量
        case 1:
          return name + " (" + this.text.rain + ")";
        // 水質
        case 6:
          return name + " (" + this.text.quality + ")";
        // ダム
        case 7:
          return name + " (" + this.text.dam + ")";
        // 海岸
        case 12:
          return name + " (" + this.text.sea + ")";
        // 積雪
        case 3:
          return name + " (" + this.text.snow + ")";
        // 危機管理型水位
        case 300:
          return name + " (" + this.text.swstg + ")";
        // 河川カメラ
        case 100:
          return name + " (" + this.text.camera + ")";
        // 簡易カメラ
        case 200:
          return name + " (" + this.text.scamera + ")";
      }
      return name;
    },
  },
  /** 監視部 */
  watch: {
    /** 観測日時を監視 */
    appTime() {
      if (this.appTime) {
        // 観測所一覧ダイアログを閉じる
        this.$store.commit("map/setShowTmList", false);
      }
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
@import "./../../scss/kwb.scss";

.tm-list {
  position: absolute;
  z-index: 3030;
  width: 100%;
  height: 100%;
  background: rgba(105, 105, 105, 0.5);
  .tm-list-child {
    width: 100%;
    height: 100%;
    .com-popup-tm-list {
      max-height: 100%;
      overflow-y: auto;
      .tm-info {
        width: 300px;
      }
    }
  }
}
</style>
